function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { keys } from 'lodash';
import { logger } from 'services';
import { PusherApi } from './http';
export class BatchAuthorizer {
    constructor(socketId, delay){
        _define_property(this, "socketId", void 0);
        _define_property(this, "delay", void 0);
        _define_property(this, "requests", void 0);
        _define_property(this, "timer", void 0);
        _define_property(this, "add", (channelName, callback)=>{
            this.requests[channelName] = callback;
            if (this.timer == null) {
                this.timer = window.setTimeout(()=>{
                    this.execute();
                    this.timer = undefined;
                }, this.delay);
            }
        });
        _define_property(this, "execute", async ()=>{
            const { socketId, requests } = this;
            this.requests = {};
            const channelNames = keys(requests);
            const request = {
                socketId,
                channelNames
            };
            logger.debug('making batch authorize request', request);
            try {
                const responses = await PusherApi.authorize(request);
                channelNames.forEach((key)=>{
                    var _responses_key;
                    const response = (_responses_key = responses[key]) !== null && _responses_key !== void 0 ? _responses_key : {
                        status: 404,
                        error: {
                            message: 'Not found'
                        }
                    };
                    const callback = requests[key];
                    if (response.status === 200) {
                        callback(null, response.data);
                    } else {
                        callback(new Error(response.error.message), {
                            auth: ''
                        });
                    }
                });
            } catch (error) {
                // `warn` — Pusher channel-auth failures are expected during session
                // transitions (logout, permission change, network blip). The
                // callbacks below propagate the error to the right consumer, so
                // there's nothing actionable from the auth call itself. Was
                // contributing ~5.7k events/day to the `status:error` filter.
                logger.warn('failed to authorize channels', {
                    request,
                    error: error
                });
                channelNames.forEach((key)=>requests[key](error, {
                        auth: ''
                    }));
            }
        });
        this.socketId = socketId;
        this.delay = delay.asMilliseconds();
        this.requests = {};
    }
}
